import axios from "axios";

// 유저 정보 가져오기 및 로그인 상태 세팅
export const checkSessionUser = async (setUserInfo, setId, setIsLoggedIn) => {
    const token = localStorage.getItem("jwtToken");
    setIsLoggedIn(!!token);

    if (!token) {
        setUserInfo(null);
        setId("");
        delete axios.defaults.headers.common.Authorization;
        return;
    }

    axios.defaults.headers.common.Authorization = `Bearer ${token}`;

    try {
        const res = await axios.get(`${process.env.REACT_APP_SPRING_API_URL}/api/session-user`);
        const user = res.data;

        if (!user || !user.username) {
            setUserInfo(null);
            setId("");
            localStorage.removeItem("jwtToken");
            delete axios.defaults.headers.common.Authorization;
            return;
        }

        setUserInfo(user);
        setId(user.username);
    } catch (err) {
        console.error(err);
        setUserInfo(null);
        setId("");
        localStorage.removeItem("jwtToken");
        delete axios.defaults.headers.common.Authorization;
    }
};
